
declare var Object: any;
export interface CustomFieldValuesViewInterface {
  "id"?: number;
  "customFieldId"?: number;
  "objectType"?: string;
  "objectId"?: number;
  "valueBool"?: number;
  "valueInt"?: number;
  "valueFloat"?: number;
  "valueString"?: string;
  "valueDate"?: any;
  "valueTime"?: string;
  "valueDatetime"?: Date;
  "valueText"?: string;
  "valueJSON"?: any;
  "value"?: string;
  "cf_id": number;
  "cf_objectId": number;
  "cf_objectType": string;
  "cf_field": string;
  "cf_label": string;
  "cf_type": string;
  "cf_optional": number;
  "cf_order": number;
  "cf_predefined": number;
  "cf_meta": any;
}

export class CustomFieldValuesView implements CustomFieldValuesViewInterface {
  "id": number;
  "customFieldId": number;
  "objectType": string;
  "objectId": number;
  "valueBool": number;
  "valueInt": number;
  "valueFloat": number;
  "valueString": string;
  "valueDate": any;
  "valueTime": string;
  "valueDatetime": Date;
  "valueText": string;
  "valueJSON": any;
  "value": string;
  "cf_id": number;
  "cf_objectId": number;
  "cf_objectType": string;
  "cf_field": string;
  "cf_label": string;
  "cf_type": string;
  "cf_optional": number;
  "cf_order": number;
  "cf_predefined": number;
  "cf_meta": any;
  constructor(data?: CustomFieldValuesViewInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `CustomFieldValuesView`.
   */
  public static getModelName() {
    return "CustomFieldValuesView";
  }

  /**
  * This method creates an instance of CustomFieldValuesView for dynamic purposes.
  **/
  public static factory(data: CustomFieldValuesViewInterface): CustomFieldValuesView{
    return new CustomFieldValuesView(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CustomFieldValuesView',
      plural: 'CustomFieldValuesViews',
      path: 'CustomFieldValuesViews',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "customFieldId": {
          name: 'customFieldId',
          type: 'number'
        },
        "objectType": {
          name: 'objectType',
          type: 'string'
        },
        "objectId": {
          name: 'objectId',
          type: 'number'
        },
        "valueBool": {
          name: 'valueBool',
          type: 'number'
        },
        "valueInt": {
          name: 'valueInt',
          type: 'number'
        },
        "valueFloat": {
          name: 'valueFloat',
          type: 'number'
        },
        "valueString": {
          name: 'valueString',
          type: 'string'
        },
        "valueDate": {
          name: 'valueDate',
          type: 'any'
        },
        "valueTime": {
          name: 'valueTime',
          type: 'string'
        },
        "valueDatetime": {
          name: 'valueDatetime',
          type: 'Date'
        },
        "valueText": {
          name: 'valueText',
          type: 'string'
        },
        "valueJSON": {
          name: 'valueJSON',
          type: 'any'
        },
        "value": {
          name: 'value',
          type: 'string'
        },
        "cf_id": {
          name: 'cf_id',
          type: 'number'
        },
        "cf_objectId": {
          name: 'cf_objectId',
          type: 'number'
        },
        "cf_objectType": {
          name: 'cf_objectType',
          type: 'string'
        },
        "cf_field": {
          name: 'cf_field',
          type: 'string'
        },
        "cf_label": {
          name: 'cf_label',
          type: 'string'
        },
        "cf_type": {
          name: 'cf_type',
          type: 'string'
        },
        "cf_optional": {
          name: 'cf_optional',
          type: 'number'
        },
        "cf_order": {
          name: 'cf_order',
          type: 'number'
        },
        "cf_predefined": {
          name: 'cf_predefined',
          type: 'number'
        },
        "cf_meta": {
          name: 'cf_meta',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
